import { Component } from '@angular/core';
import { UrlTrackerService } from '@app/core/services/url-tracker/url-tracker.service';
import { Location } from '@angular/common';
import { Router } from '@angular/router';

@Component({
  selector: 'ag-four-oh-four',
  templateUrl: './four-oh-four.component.html',
  styleUrls: ['./four-oh-four.component.scss'],
  standalone: false,
})
export class FourOhFourComponent {
  previousUrl: string;

  constructor(
    private router: Router,
    urlTrackerService: UrlTrackerService,
    private location: Location,
  ) {
    this.previousUrl = urlTrackerService.previousUrl;
  }

  goBack(): void {
    this.location.back();
  }

  goHome(): void {
    this.router.navigate(['account'], { replaceUrl: true });
  }
}
